import 'ui-theme/js/components/article';

/// Document TOC creator
UX.article.toc__create = function () {
    const $sections = (UX.article.$sections = $(UX.settings.article.selector.toc__targets));
    const $nav = (UX.article.$nav = $(UX.settings.article.selector.toc__nav));
    const $block = (UX.article.$ctrl = $(UX.settings.article.selector.toc__block));
    const $articleContent = (UX.article.$articleContent = $(UX.settings.article.selector.article__content));
    UX.article.offset =
        ($('.header').outerHeight() || 0) +
        ($('.navbar').outerHeight() || 0) +
        ($('.article__navbar').outerHeight() || 0);

    if (!$nav.length || !($sections.length > 1)) {
        $nav.remove();
        $block.remove();
        return;
    }

    $articleContent.addClass('has-sections');

    const ul = $('<ul class="rlist w-slide--list" role="menu"/>').appendTo($nav);
    $sections.each(function () {
        const $this = $(this).clone();
        const $li = $('<li/>').attr('role', 'menuitem').appendTo(ul),
            $link = $('<a class="w-slide__hide"/>')
                .attr('href', '#' + $this.attr('id'))
                .appendTo($li);
        $this.removeAttr('class');
        $this.removeAttr('id');
        $this.find('.ref').remove();
        $('<span/>').html($this.html()).appendTo($link);
    });
};
